import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom-v5-compat';
import { handleSuccessToast } from 'src/components/molecules';
import { useResetPasswordMutation } from 'src/graphql';
import { handleUpdatePasswordErrors } from 'src/utils/handleUpdatePasswordErrors';
import * as Types from '../../../types';
import {
  ChangePasswordNewCommon,
  FormValues,
} from '../../organisms/ChangePasswordNew/ChangePasswordNewCommon';
import { ResetResult } from '../../organisms/Common/ResetResult/ResetResult';
import {
  Description,
  FormContainer,
  Header,
} from '../../organisms/Reporting/ReportingReset/ReportingReset.styles';
import { OpenReportingContainer } from '../OpenReportingContainer/OpenReportingContainer';

interface OPRResetPageProps {
  organisation: string;
  logo: string;
  isOprPasswordResetEnabled: boolean;
}

const OPRResetPage: React.FC<OPRResetPageProps> = (props) => {
  const { t } = useTranslation();
  const { token, slug } = useParams<{ slug: string; token?: string }>();
  const [hasSubmitted, setHasSubmitted] = useState<boolean>(false);

  const navigate = useNavigate();

  const updatePassword = useResetPasswordMutation({
    onSuccess() {
      handleSuccessToast({
        toastMessage: t(
          'reporting.ReportingForgotPassword.updatePasswordSuccess',
        ),
        toastDescription: t(
          'reporting.ReportingForgotPassword.updatePasswordSuccessDescription',
        ),
      });

      setHasSubmitted(true);
    },
    onError(error: unknown) {
      handleUpdatePasswordErrors((error as Error).message);
    },
  });

  const createPassword = async (data: FormValues) => {
    const { newPassword } = data;

    if (token && props.isOprPasswordResetEnabled) {
      updatePassword.mutate({
        token,
        password: newPassword,
      });
    }
  };

  if (!token) {
    navigate(`/${slug}/open-reporting`);
    return null;
  }
  return (
    <OpenReportingContainer organisation={props.organisation} logo={props.logo}>
      {hasSubmitted ? (
        <ResetResult isSuccess={updatePassword.isSuccess} isReporting={false} />
      ) : (
        <div data-testid="reset">
          <Header>{t('public.Password.createNewPassword')}</Header>
          <Description>{t('public.Password.newDescription')}</Description>
          <FormContainer>
            <ChangePasswordNewCommon
              createPassword={createPassword}
              updateWithToken={true}
              isLoading={false}
              buttonText={t(
                'reporting.ReportingChangePassword.updatePasswordCTA',
              )}
              isLocalised={true}
              data-testid="opr-update-password"
            />
          </FormContainer>
        </div>
      )}
    </OpenReportingContainer>
  );
};

const mapStateToProps = (state: Types.State) => ({
  organisation: state.openReporting?.openReportReducer?.organisation ?? '',
  logo: state?.openReporting?.openReportReducer?.logo ?? '',
});

export default connect(mapStateToProps)(OPRResetPage);
